import { render } from "./COIQuery.vue?vue&type=template&id=1915adcd&scoped=true"
import script from "./COIQuery.vue?vue&type=script&lang=js"
export * from "./COIQuery.vue?vue&type=script&lang=js"

import "./COIQuery.vue?vue&type=style&index=0&id=1915adcd&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1915adcd"]])

export default __exports__